import React from 'react';
import { RouterProps } from 'react-router';

import DigitalShoppingPass from './DigitalShoppingPass/DigitalShoppingPass';

type PropTypes = RouterProps;

const CheckoutApprovalLoader: React.FC<PropTypes> = props => {
  return <DigitalShoppingPass checkoutApproval={true} {...props} />;
};

export default CheckoutApprovalLoader;
